import React from 'react';
import { Code, BookOpen, Cpu } from 'lucide-react';
import { TechnicalExpertise, QuestionnaireData } from '../../types';

interface TechnicalExpertiseStepProps {
  data: Partial<QuestionnaireData>;
  onChange: (data: Partial<QuestionnaireData>) => void;
}

const expertiseLevels = [
  {
    id: 'beginner' as TechnicalExpertise,
    title: 'Beginner',
    description: 'I prefer simple, easy-to-use tools',
    icon: BookOpen
  },
  {
    id: 'intermediate' as TechnicalExpertise,
    title: 'Intermediate',
    description: 'I can handle moderately complex tools',
    icon: Code
  },
  {
    id: 'advanced' as TechnicalExpertise,
    title: 'Advanced',
    description: 'I\'m comfortable with complex technical tools',
    icon: Cpu
  }
];

export function TechnicalExpertiseStep({ data, onChange }: TechnicalExpertiseStepProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {expertiseLevels.map((level) => {
        const Icon = level.icon;
        return (
          <button
            key={level.id}
            onClick={() => onChange({ technicalExpertise: level.id })}
            className={`p-6 rounded-xl border-2 transition-all ${
              data.technicalExpertise === level.id
                ? 'border-blue-600 bg-blue-50'
                : 'border-gray-200 hover:border-blue-200 hover:bg-gray-50'
            }`}
          >
            <Icon className={`w-8 h-8 mb-4 ${
              data.technicalExpertise === level.id ? 'text-blue-600' : 'text-gray-600'
            }`} />
            <h3 className="text-lg font-semibold mb-2">{level.title}</h3>
            <p className="text-gray-600">{level.description}</p>
          </button>
        );
      })}
    </div>
  );
}

export default TechnicalExpertiseStep;